<template>
    <div class="jetlympic-entrance">
      <img class="banner" src="@/assets/jetlympic/banner.png" />
       <div class="header">
            <img src="@/assets/jetlympic/logo.png" />
       </div>
       <div class="switch">
           中文 <van-switch style="margin: 0 12px;" size="24" v-model="checked" active-color="#FFF" inactive-color="#FFFFFF" @change="switchLanguage" /> EN
       </div>
        <div class="list">
          <div class="item" @click="handleItemClick('https://www.zphdev.online/#/home')">
            <div class="title">{{ $t(`jetlympic.entrance.text_1`) }}</div>
          </div>
          <div class="item" @click="handleItemClick('home')">
            <div class="title">{{ $t(`jetlympic.entrance.text_2`) }}</div>
          </div>
       </div>
       <div class="footer">POWER BY BMBsports</div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Switch } from 'vant';
Vue.use(Switch);
export default {
    data() {
        return {
          checked: this.$i18n.locale === 'en',
        };
    },
  mounted() {
        window.localStorage.setItem('jetlympic', 'jetlympic');
    },
  methods: {
      switchLanguage(value) {
            // value为true时切换到英文，false时切换到中文
            const language = value ? 'en' : 'zh';
            this.$i18n.locale = language;
            localStorage.setItem('language', language);
        },
    handleItemClick(name) {
              
      if (name === 'home') { 
        this.$router.push({ path: `/jetlympic/${name}` });
      } else {
        window.location.href = name
      }
    }
  },
};
</script>

<style scoped lang="scss">
.jetlympic-entrance{
    padding: 0 18px;
    width: 100%;
    height: 100vh;
    background-color: #00A7FF;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 18px;
    .banner{
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      opacity: 0.6;
    }
    .header{
        text-align: center;
        padding-top: 14px;
        img{
            width: 240px;
        }
    }
    .switch{
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        margin-top: 14px;
    }
    .list{
      margin-top: 24px;
      position: relative;
      z-index: 3;
      .item{
        height: 48px;
        background-color: #fff;
        color: #00A7FF;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 3px;
        margin-bottom: 12px;
      }
    }
    .footer{
      position: absolute;
      bottom: 18px;
      width: 100%;
        text-align: center;
        color: rgba(255, 255, 255, 0.4);
        font-size: 13px;
        margin-top: 18px;
    }
}

:deep(.van-switch__node){
  background-color: #00A7FF;
}
</style>
